<template>
  <b-modal
    ref="modalDetalhamentoOportunidade"
    size="xl"
    no-close-on-background
    hide-footer
    :dialog-class="'alteracao-tamanho'"
    :modal-class="'center-modal'"
    @hidden="onModalHidden"
  >
    <section class="deal-modal-header">
      <div class="deal-header-left">
        <div class="deal-title-row">
          <div class="deal-icon">
            <font-awesome-icon :icon="faFolderOpen" />
          </div>

          <div class="deal-title-stack">
            <div class="deal-kicker">
              Jornada <span class="deal-kicker-id">#{{ oportunidade.id || '—' }}</span>
            </div>

            <h3
              class="deal-title deal-header-link cursor-pointer"
              style="color: black;"
              @click="abrirPaginaEmpresaOuPessoa"
            >
              {{ empresaHeaderNome }}
            </h3>

            <div class="deal-meta deal-meta--stack">
              <div
                v-if="empresaHeaderCnpjRaw"
                class="deal-meta-item deal-header-cnpj"
              >
                <span class="deal-meta-text">
                  {{ empresaHeaderCnpjLabel }}
                </span>
                <b-button
                  v-b-tooltip.hover.top="'Copiar CNPJ'"
                  variant="link"
                  class="btn-copy-cnpj p-0"
                  @click="copiarCnpj"
                >
                  <font-awesome-icon :icon="faCopy" />
                </b-button>
              </div>

              <div
                v-if="empresaHeaderEnderecoRaw && empresaHeaderEnderecoMapsUrl"
                class="deal-meta-item"
              >
                <a
                  class="deal-header-link"
                  :href="empresaHeaderEnderecoMapsUrl"
                  target="_blank"
                  rel="noopener"
                >
                  <font-awesome-icon
                    :icon="faMapMarkerAlt"
                    class="mr-1 deal-address-icon"
                  />
                  <span class="deal-meta-text">
                    {{ empresaHeaderEnderecoRaw }}
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="deal-header-right">
        <cadastro-proposta
          ref="cadastroProposta"
          class="mr-1"
          :empresa-inicial="empresaInicialParaProposta"
          :pessoa-inicial="pessoaInicialParaProposta"
          :deal-id="oportunidade.id"
          :proposta-id-atual="propostaIdAtual"
          @fechar-proposta="propostaIdAtual = null"
        />
      </div>
    </section>

    <div class="deal-modal-divider" />

    <div class="detalhe-modal">
      <aside class="painel-info painel-info--premium">
        <div class="info-header">
          <div>
            <h5 class="mb-0">
              Resumo
            </h5>
            <small class="info-subtitle">Dados rápidos da oportunidade</small>
          </div>
        </div>

        <ul class="info-list">
          <li class="info-item">
            <div class="info-icon-wrap">
              <font-awesome-icon
                :icon="faClipboardList"
                class="info-icon"
              />
            </div>
            <div class="info-content">
              <span class="info-label">Pacote Contrato</span>
              <span class="info-value">
                {{ pacoteContratoNomeExibicao }}
              </span>
            </div>
          </li>

          <li class="info-item">
            <div class="info-icon-wrap">
              <font-awesome-icon
                :icon="faMoneyBillWave"
                class="info-icon"
              />
            </div>
            <div class="info-content">
              <span class="info-label">Honorários</span>
              <span class="info-value">{{ honorariosExibicao }}</span>
            </div>
          </li>

          <li class="info-item info-item--stack">
            <div class="info-item-row">
              <div class="info-icon-wrap">
                <font-awesome-icon
                  :icon="faFileInvoiceDollar"
                  class="info-icon"
                />
              </div>

              <div class="info-content">
                <div class="info-title-row">
                  <span class="info-label info-label--bigger">PROPOSTAS</span>
                  <span class="info-pill">{{ propostasResumo.total }}</span>
                </div>

                <div
                  v-if="propostasResumo.total > 0"
                  class="ratio-bar"
                >
                  <div
                    class="ratio-seg ratio-seg--green"
                    :style="{ width: pct(propostasResumo.aprovadas, propostasResumo.total) + '%' }"
                  />
                  <div
                    class="ratio-seg ratio-seg--yellow"
                    :style="{ width: pct(propostasResumo.aguardandoEnvio, propostasResumo.total) + '%' }"
                  />
                  <div
                    class="ratio-seg ratio-seg--red"
                    :style="{ width: pct(propostasResumo.naoAprovadas, propostasResumo.total) + '%' }"
                  />
                </div>
                <div
                  v-else
                  class="ratio-bar ratio-bar--empty"
                />

                <div class="ratio-legend">
                  <span class="legend-item">
                    <span class="dot dot--green" /> {{ propostasResumo.aprovadas }}
                  </span>
                  <span class="legend-item">
                    <span class="dot dot--yellow" /> {{ propostasResumo.aguardandoEnvio }}
                  </span>
                  <span class="legend-item">
                    <span class="dot dot--red" /> {{ propostasResumo.naoAprovadas }}
                  </span>
                  <span class="legend-total">Total: {{ propostasResumo.total }}</span>
                </div>
              </div>
            </div>
          </li>

          <li class="info-item info-item--stack">
            <div class="info-item-row">
              <div class="info-icon-wrap">
                <font-awesome-icon
                  :icon="faFileSignature"
                  class="info-icon"
                />
              </div>

              <div class="info-content">
                <div class="info-title-row">
                  <span class="info-label info-label--bigger">CONTRATOS</span>
                  <span class="info-pill">{{ contratosResumo.total }}</span>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </aside>

      <div class="painel-conteudo">
        <div class="empresa-info-wrapper">
          <div class="empresa-info-card">
            <div class="empresa-info-card-header">
              <h6 class="mb-0">
                Dados fiscais
              </h6>
              <small class="text-muted empresa-info-subtitle">
                Informações do cadastro da empresa
              </small>
            </div>

            <div class="empresa-info-grid empresa-info-grid-top">
              <div class="empresa-info-item">
                <div class="empresa-info-label">
                  Enquadramento
                </div>
                <div class="empresa-info-value">
                  {{ enquadramentoExibicao }}
                </div>
              </div>

              <div class="empresa-info-item">
                <div class="empresa-info-label">
                  Porte
                </div>
                <div class="empresa-info-value">
                  —
                </div>
              </div>

              <div class="empresa-info-item">
                <div class="empresa-info-label">
                  CNAE Principal
                </div>
                <div class="empresa-info-value empresa-info-wrap">
                  {{ cnaeExibicao }}
                </div>
              </div>
            </div>
          </div>

          <div class="empresa-info-card empresa-info-card--contacts">
            <div class="empresa-info-card-header empresa-info-card-header--collapsible">
              <div class="header-left">
                <h6 class="mb-0">
                  Contatos
                </h6>
                <span class="contacts-count">{{ contatosRows.length }}</span>
              </div>

              <b-button
                variant="link"
                class="btn-toggle-collapse"
                @click="toggleContatos"
              >
                <font-awesome-icon :icon="contatosAberto ? faChevronUp : faChevronDown" />
              </b-button>
            </div>

            <b-collapse
              id="collapseContatosEmpresa"
              v-model="contatosAberto"
            >
              <div class="contacts-body">
                <div
                  v-if="carregandoPessoasEmpresa"
                  class="text-muted contacts-loading"
                >
                  Carregando...
                </div>

                <div v-else>
                  <table
                    v-if="contatosRows.length"
                    class="contacts-table"
                  >
                    <thead>
                      <tr>
                        <th>Tipo</th>
                        <th>Nome</th>
                        <th>Email</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(c, idx) in contatosRows"
                        :key="`${c.key || idx}`"
                      >
                        <td>
                          <span
                            class="pill-type"
                            :class="c.tipoClass"
                          >
                            {{ c.tipoLabel }}
                          </span>
                        </td>
                        <td class="cell-strong">
                          {{ c.nome || '—' }}
                        </td>
                        <td>
                          <div class="cell-with-action">
                            <span>{{ c.email || '—' }}</span>
                            <font-awesome-icon
                              v-if="c.email"
                              :icon="faCopy"
                              class="copy-icon"
                              @click="copiarTexto(c.email, 'Email copiado!')"
                            />
                          </div>
                        </td>
                        <td>
                          <div class="cell-with-action">
                            <font-awesome-icon
                              v-if="c.ramal"
                              :icon="faCopy"
                              class="copy-icon"
                              @click="copiarTexto(String(c.ramal), 'Ramal copiado!')"
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <div
                    v-else
                    class="text-muted contacts-empty"
                  >
                    Nenhum contato vinculado
                  </div>
                </div>
              </div>
            </b-collapse>
          </div>
        </div>

        <b-tabs
          pills
          card
          class="abas"
        >
          <b-tab
            title="Resumo"
            active
          >
            <aba-geral-oportunidade :deal="oportunidade" />
          </b-tab>

          <b-tab title="Atividade">
            <aba-atividade-oportunidade :deal-id="oportunidade.id" />
          </b-tab>

          <b-tab title="Propostas">
            <propostas-tabela
              :oportunidade-id="oportunidade.id"
              @detalhar-proposta="abrirModalProposta"
              @stats="onPropostasStats"
            />
          </b-tab>

          <b-tab title="Documentos">
            <documentos-oportunidade
              :deal-id="oportunidade.id"
              :pode-deletar="true"
              @stats="onDocumentosStats"
            />
          </b-tab>

          <b-tab title="Societário">
            <aba-societario-oportunidade
              :empresa="empresaCadastro"
              :carregando="carregandoEmpresaCadastro"
            />
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </b-modal>
</template>

<style scoped>
.empresa-info-card--contacts {
  margin-top: 12px;
  overflow: hidden;
}

.empresa-info-card-header--collapsible {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.empresa-info-card-header--collapsible .header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.contacts-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 26px;
  height: 22px;
  padding: 0 8px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  background: #f1f3f5;
  color: #495057;
}

.btn-toggle-collapse {
  padding: 0;
  line-height: 1;
  color: #495057;
}

.btn-toggle-collapse:hover {
  color: #111;
  text-decoration: none;
}

.contacts-body {
  padding: 10px 0 2px 0;
}

.contacts-loading,
.contacts-empty {
  padding: 12px 16px;
}

.contacts-table {
  width: 100%;
  border-collapse: collapse;
}

.contacts-table thead th {
  padding: 10px 16px;
  text-align: left;
  font-weight: 600;
  font-size: 13px;
  border-top: 1px solid #f1f1f1;
  border-bottom: 1px solid #f1f1f1;
  color: #495057;
  background: #fff;
}

.contacts-table tbody td {
  padding: 12px 16px;
  border-bottom: 1px solid #f5f5f5;
  font-size: 13px;
  color: #212529;
  vertical-align: middle;
}

.contacts-table tbody tr:nth-child(even) td {
  background: #fafafa;
}

.cell-strong {
  font-weight: 600;
}

.pill-type {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 22px;
  padding: 0 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
}

.pill-type--internal {
  background: #111827;
  color: #fff;
}

.pill-type--external {
  background: #e9ecef;
  color: #343a40;
}

.cell-with-action {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.copy-icon {
  cursor: pointer;
  color: #6c757d;
  transition: 0.15s ease;
  font-size: 14px;
}

.copy-icon:hover {
  color: #111;
}
</style>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faPlus,
  faArrowsAlt,
  faArrowUp,
  faInfoCircle,
  faFolderOpen,
  faBuilding,
  faMoneyBillWave,
  faUser,
  faCalendarAlt,
  faClipboardList,
  faPen,
  faTimes,
  faSave,
  faClock,
  faBell,
  faCopy,
  faFileInvoiceDollar,
  faFileSignature,
  faMapMarkerAlt,
  faChevronDown,
  faChevronUp,
} from '@fortawesome/free-solid-svg-icons'
import api from '@/app-modulo/comercial/oportunidades/shared/services/api'
import documentosApi from '@/shared/components/documentos-oportunidade/shared/services/api'
import propostaApi from '@/app-modulo/comercial/cadastro-proposta/shared/services/api'
import empresaApi from '@/app-modulo/comuns/empresa/shared/services/api'
import * as oppUtils from '@/app-modulo/comercial/oportunidades/shared/utils'
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'ModalDetalhesOportunidade',

  components: {
    FontAwesomeIcon,
    AbaGeralOportunidade: () => import('@/app-modulo/comercial/oportunidades/shared/components/aba-geral-oportunidade/AbaGeralOportunidade.vue'),
    AbaAtividadeOportunidade: () => import('@/app-modulo/comercial/oportunidades/shared/components/aba-atividades-oportunidade/AbaAtividadeOportunidade.vue'),
    CadastroProposta: () => import('@/app-modulo/comercial/cadastro-proposta/CadastroProposta.vue'),
    PropostasTabela: () => import('@/shared/components/propostas-tabela/PropostasTabela.vue'),
    DocumentosOportunidade: () => import('@/shared/components/documentos-oportunidade/DocumentosOportunidade.vue'),
    AbaSocietarioOportunidade: () => import('../aba-societario-oportunidade/AbaSocietarioOportunidade.vue'),
  },
  props: {
    oportunidadeId: {
      type: Number,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      faPlus,
      faArrowsAlt,
      faArrowUp,
      faInfoCircle,
      faFolderOpen,
      faBuilding,
      faMoneyBillWave,
      faUser,
      faCalendarAlt,
      faClipboardList,
      faPen,
      faTimes,
      faSave,
      faClock,
      faBell,
      faCopy,
      faFileInvoiceDollar,
      faFileSignature,
      faMapMarkerAlt,
      faChevronDown,
      faChevronUp,

      propostaIdAtual: null,
      empresaCadastro: null,
      carregandoEmpresaCadastro: false,
      oportunidade: this.novaOportunidadeBase(),

      contratosResumo: {
        aprovadas: 0,
        aguardandoEnvio: 0,
        naoAprovadas: 0,
        total: 0,
      },
      pacoteContratoNome: '',
      honorariosValor: null,
      documentosResumo: {
        total: 0,
        contratos: 0,
      },
      propostasResumo: {
        total: 0,
        aprovadas: 0,
        aguardandoEnvio: 0,
        naoAprovadas: 0,
        abertas: 0,
      },
      documentosLista: [],
      pessoasEmpresa: [],
      carregandoPessoasEmpresa: false,
      contatosAberto: true,
    }
  },
  computed: {
    empresaInicialParaProposta() {
      if (!this.oportunidade || !this.oportunidade.companyId) return null
      return {
        id: this.oportunidade.companyId,
        razaoSocial: this.oportunidade.company.razaoSocial || '',
        cadastroFederal: this.oportunidade.company.cadastroFederal || '',
        pessoaPreferidaId: this.oportunidade.personId || null,
      }
    },
    pessoaInicialParaProposta() {
      if (!this.oportunidade || !this.oportunidade.personId) return null
      return {
        id: this.oportunidade.personId,
        nome: this.oportunidade.cliente || '',
      }
    },
    enquadramentoExibicao() {
      const val = this.extrairEnquadramento(this.empresaCadastro)
      return val || 'Não informado'
    },
    cnaeExibicao() {
      const val = this.extrairCnaePrincipal(this.empresaCadastro)
      return val || 'Não informado'
    },

    empresaHeaderNome() {
      const opp = this.oportunidade || {}
      if (!opp.companyId) {
        if (opp.company && opp.company.razaoSocial) return opp.company.razaoSocial
        if (opp.cliente) return opp.cliente.nome
        return 'Empresa não informada'
      }

      if (this.carregandoEmpresaCadastro) return 'Carregando...'

      const emp = this.empresaCadastro || {}
      return emp.razaoSocial || emp.nomeFantasia || emp.nome || opp.empresa || 'Empresa não encontrada'
    },

    empresaHeaderCnpjRaw() {
      if (!this.oportunidade || !this.oportunidade.companyId) return ''
      if (this.carregandoEmpresaCadastro) return ''
      const emp = this.empresaCadastro || {}
      return emp.cadastroFederal || emp.cnpj || this.oportunidade.empresaCnpj || ''
    },
    empresaHeaderCnpjLabel() {
      const cnpj = this.empresaHeaderCnpjRaw
      return cnpj ? `CNPJ: ${cnpj}` : 'CNPJ não informado'
    },

    empresaHeaderEnderecoRaw() {
      if (!this.oportunidade || !this.oportunidade.companyId) return ''
      if (this.carregandoEmpresaCadastro) return ''
      return this.formatarEnderecoEmpresa(this.empresaCadastro) || ''
    },
    empresaHeaderEnderecoMapsUrl() {
      const endereco = this.empresaHeaderEnderecoRaw
      if (!endereco) return ''
      return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(endereco)}`
    },

    pacoteContratoNomeExibicao() {
      return (this.pacoteContratoNome || '').trim() || '—'
    },

    honorariosExibicao() {
      if (this.honorariosValor === null || this.honorariosValor === undefined || this.honorariosValor === '') return '—'
      return this.formatarValor(this.honorariosValor)
    },

    contatosRows() {
      const arr = Array.isArray(this.pessoasEmpresa) ? this.pessoasEmpresa : []
      return arr.map((p, idx) => {
        const tipo = this.extrairTipoContato(p)
        const tipoLabel = tipo || '—'
        const tipoClass = String(tipoLabel).toLowerCase().includes('intern') ? 'pill-type--internal' : 'pill-type--external'
        return {
          key: p?.id ?? p?.Id ?? p?.personId ?? p?.pessoaId ?? idx,
          tipoLabel,
          tipoClass,
          nome: this.extrairNomePessoa(p),
          email: this.extrairEmailPessoa(p),
          cargo: this.extrairCargoPessoa(p),
          ramal: this.extrairRamalPessoa(p),
        }
      }).filter(Boolean)
    },
  },
  watch: {
    'novaOportunidade.company': 'onNovaOportunidadeCompanyChanged',
  },
  mounted() {
    if (!this.autoOpenFromRoute) return

    if (this.$route && this.$route.name === 'detalhes-oportunidade') {
      const routeId = (this.$route && this.$route.params && this.$route.params.oportunidadeId) ? this.$route.params.oportunidadeId : null
      if (routeId) {
        this.showModal()
      }
    }
  },
  methods: {
    toggleContatos() {
      this.contatosAberto = !this.contatosAberto
    },
    toStringTrim(v) {
      if (v === null || v === undefined) return ''
      return String(v).trim()
    },
    extrairNomePessoa(p) {
      if (!p) return ''
      const candidatos = [
        p.nome,
        p.name,
        p.nomeCompleto,
        p.fullName,
        p.pessoaNome,
        p.personName,
        p.contactName,
        p.usuarioNome,
        p.userName,
        p.pessoa && (p.pessoa.nome || p.pessoa.name || p.pessoa.nomeCompleto),
        p.person && (p.person.nome || p.person.name || p.person.fullName),
      ]
      const nome = candidatos.map(v => this.toStringTrim(v)).find(v => v && v.length > 0)
      return nome || ''
    },
    extrairEmailPessoa(p) {
      if (!p) return ''
      const candidatos = [
        p.email,
        p.mail,
        p.emailAddress,
        p.enderecoEmail,
        p.contactEmail,
        p.pessoa && (p.pessoa.email || p.pessoa.mail),
        p.person && (p.person.email || p.person.mail),
      ]
      const email = candidatos.map(v => this.toStringTrim(v)).find(v => v && v.includes('@'))
      return email || ''
    },
    extrairCargoPessoa(p) {
      if (!p) return ''
      const candidatos = [
        p.cargo,
        p.role,
        p.funcao,
        p.position,
        p.jobTitle,
        p.departamento,
        p.department,
        p.pessoa && (p.pessoa.cargo || p.pessoa.role),
        p.person && (p.person.cargo || p.person.role),
      ]
      const cargo = candidatos.map(v => this.toStringTrim(v)).find(v => v && v.length > 0)
      return cargo || ''
    },
    extrairRamalPessoa(p) {
      if (!p) return ''
      const candidatos = [
        p.ramal,
        p.extension,
        p.ext,
        p.ramalTelefone,
        p.phoneExtension,
        p.pessoa && (p.pessoa.ramal || p.pessoa.extension),
        p.person && (p.person.ramal || p.person.extension),
      ]
      const ramal = candidatos.map(v => this.toStringTrim(v)).find(v => v && v.length > 0)
      return ramal || ''
    },
    extrairTipoContato(p) {
      if (!p) return ''
      const candidatos = [
        p.tipo,
        p.type,
        p.contactType,
        p.tipoContato,
        p.tipoVinculo,
        p.vinculo,
        p.kind,
        p.isInternal === true ? 'Interno' : '',
        p.interno === true ? 'Interno' : '',
        p.internal === true ? 'Interno' : '',
        p.isExternal === true ? 'Externo' : '',
        p.externo === true ? 'Externo' : '',
        p.external === true ? 'Externo' : '',
      ]
      const tipo = candidatos.map(v => this.toStringTrim(v)).find(v => v && v.length > 0)
      return tipo || 'Externo'
    },
    statusNumeroProposta(p) {
      const raw = p?.status ?? p?.statusId ?? p?.statusProposta ?? p?.Status ?? p?.StatusId ?? null
      const n = Number(raw)
      return Number.isFinite(n) ? n : null
    },
    isPropostaAprovada(p) {
      if (!p) return false
      const st = this.statusNumeroProposta(p)
      if (st !== null) return st === 3 || st === 8 || st === 9
      if (p.aprovada === true || p.isApproved === true || p.approved === true) return true
      const s = String(p?.status || p?.situacao || p?.state || '').toLowerCase()
      return s.includes('aprovad') || s.includes('aceit') || s === 'approved' || s.includes('ganh') || s.includes('conclu') || s.includes('finaliz')
    },
    salvarCampoLivre(chave) {
      const v = this.empresaLivres[chave]
      if (typeof v === 'string') {
        this.empresaLivres[chave] = v.trim()
      }
      if (this.$sucesso) this.$sucesso('Salvo!')
    },
    showModal() {
      if (!this.oportunidade) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro ao carregar oportunidade',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        })
        return
      }

      api.getDealById(this.oportunidadeId).then(response => {
        const deal = response.data || {}

        const personObj = deal.person || deal.personData || deal.personDTO || null
        const personId = deal.personId || (personObj && (personObj.id || personObj.personId)) || null

        const companyObj = deal.company || deal.companyData || null
        const companyId = deal.companyId || (companyObj && (companyObj.id || companyObj.companyId)) || null

        const clienteNome = this.extrairNomePessoa(personObj) || deal.personName || deal.personNameDisplay || ''

        this.oportunidade = {
          titulo: deal.title || deal.titulo || clienteNome || '',
          id: deal.id || deal.dealId || null,
          cliente: personObj || (clienteNome ? { nome: clienteNome } : null),
          personId,
          company: companyObj || null,
          companyId,
          empresaCnpj: companyObj?.cadastroFederal || companyObj?.cnpj || deal.empresaCnpj || null,
          valor: (deal.estimatedValue !== undefined && deal.estimatedValue !== null) ? deal.estimatedValue : (deal.valor ?? null),
          status: deal.status || deal.situacao || '',
          responsavel: deal.owner || (deal.ownerId ? { id: deal.ownerId } : null),
          prazo: deal.expectedCloseDate || deal.prazo || '',
          cadastro: deal.dataCadastro || deal.createdAt || null,
          respCadastro: deal.usuCadastro || deal.createdBy || 'Sistema',
          proposalTotal: deal.proposalTotal ?? null,
          proposalCount: deal.proposalCount ?? 0,
        }
        if (deal.proposalTotal !== undefined && deal.proposalTotal !== null && deal.proposalTotal !== '') {
          this.honorariosValor = deal.proposalTotal
        }
        this.carregarEmpresaCadastro(this.oportunidade.companyId)
        this.carregarPessoasEmpresa(this.oportunidade.companyId)
        this.carregarInfoUltimaPropostaAprovada(this.oportunidade.id)
        this.carregarDocumentosParaResumo(this.oportunidade.id)
        this.$refs.modalDetalhamentoOportunidade.show()
      })
    },
    abrirModalProposta(proposta) {
      this.propostaIdAtual = proposta.id
      this.$refs.cadastroProposta.showModal()
    },
    onNovaOportunidadeCompanyChanged(novaEmpresa, empresaAnterior) {
      const novoId = novaEmpresa && novaEmpresa.id
      const anteriorId = empresaAnterior && empresaAnterior.id
      if (novoId !== anteriorId) {
        this.novaOportunidade.person = null
      }
    },

    async carregarInfoUltimaPropostaAprovada(dealId) {
      if (!dealId) return
      try {
        const res = await api.getDealProposals(dealId)
        const propostas = (res && res.data) ? res.data : []
        const totalEmitidas = Array.isArray(propostas) ? propostas.length : 0

        const aprovadas = propostas.filter(p => this.isPropostaAprovada(p)).length
        const naoAprovadas = propostas.filter(p => this.isPropostaNaoAprovada(p)).length
        const aguardandoEnvio = propostas.filter(p => !this.isPropostaAprovada(p) && !this.isPropostaNaoAprovada(p) && this.isPropostaAguardando(p)).length
        const abertasCalc = totalEmitidas - aprovadas - naoAprovadas

        this.propostasResumo = {
          ...this.propostasResumo,
          total: totalEmitidas,
          aprovadas,
          aguardandoEnvio,
          naoAprovadas,
          abertas: abertasCalc < 0 ? 0 : abertasCalc,
        }

        const getId = p => p?.id ?? p?.Id ?? p?.propostaId ?? p?.PropostaId ?? null
        const getValor = p => {
          const raw = p?.valor ?? p?.Valor ?? p?.valorTotal ?? p?.ValorTotal ?? p?.total ?? p?.Total ?? 0
          const n = typeof raw === 'string'
            ? Number(String(raw).replace(/[^\d,-]/g, '').replace(/\./g, '').replace(',', '.'))
            : Number(raw)
          return Number.isFinite(n) ? n : 0
        }

        const propostasValidas = Array.isArray(propostas) ? propostas.filter(p => getId(p)) : []
        propostasValidas.sort((a, b) => Number(getId(b)) - Number(getId(a)))
        const propostaMaisRecente = propostasValidas[0] || null
        const valorMaisRecente = propostaMaisRecente ? getValor(propostaMaisRecente) : 0
        if (valorMaisRecente > 0) this.honorariosValor = valorMaisRecente

        const aprovadasIds = propostasValidas
          .filter(p => this.isPropostaAprovada(p))
          .map(p => getId(p))
          .filter(Boolean)
          .sort((a, b) => Number(b) - Number(a))

        const todasIds = propostasValidas
          .map(p => getId(p))
          .filter(Boolean)
          .sort((a, b) => Number(b) - Number(a))

        const propostaIdParaResumo = aprovadasIds[0] || todasIds[0] || null
        if (propostaIdParaResumo) {
          await this.carregarPacoteContratoDaPropostaDetalhada(propostaIdParaResumo)
        } else {
          this.pacoteContratoNome = ''
          this.honorariosValor = null
        }
      } catch (e) {
        this.propostasResumo = {
          ...this.propostasResumo,
          total: 0,
          aprovadas: 0,
          aguardandoEnvio: 0,
          naoAprovadas: 0,
          abertas: 0,
        }
        this.pacoteContratoNome = ''
        this.honorariosValor = null
      }
    },
    isPropostaNaoAprovada(p) {
      const st = this.statusNumeroProposta(p)
      if (st !== null) return st === 4 || st === 5 || st === 7
      const s = String(p?.status || p?.situacao || p?.state || '').toLowerCase()
      return s.includes('reprov') || s.includes('recus') || s.includes('perdid') || s.includes('cancel')
    },

    isPropostaAguardando(p) {
      const st = this.statusNumeroProposta(p)
      if (st !== null) return st === 1 || st === 2 || st === 6 || st === 9
      const s = String(p?.status || p?.situacao || p?.state || '').toLowerCase()
      return s.includes('rascunh') || s.includes('envi') || s.includes('aguard') || s.includes('assin')
    },
    normalizarTipoDocumento(doc) {
      if (!doc) return { id: null, nome: '' }

      const candidatos = [
        doc.documentType,
        doc.DocumentType,
        doc.documentTypeId,
        doc.document_type,
        doc.tipoDoc,
        doc.tipoDocumento,
        doc.tipoDocumentoId,
        doc.typeId,
        doc.type_id,
        doc.tipo,
        doc.type,
        doc.documentTypeObj,
        doc.documentTypeObject,
        doc.documentTypeObjDto,
        doc.tipoObj,
        doc.tipoDocumentoObj,
        doc.documentTypeName,
        doc.documentTypeDescricao,
        doc.documentTypeDescription,
        doc.category,
        doc.categoria,
      ]

      let id = null
      let nome = ''

      candidatos.forEach(c => {
        if (!c) return

        if (typeof c === 'number' || typeof c === 'string') {
          const n = Number(c)
          if (id === null && Number.isFinite(n)) id = n
          if (!nome && typeof c === 'string') nome = c
          return
        }

        if (typeof c === 'object') {
          let rawId = NaN
          if (c.id !== undefined) rawId = c.id
          else if (c.value !== undefined) rawId = c.value

          const idCand = Number(rawId)
          if (id === null && Number.isFinite(idCand)) id = idCand

          const nomeCand = c.nome || c.name || c.descricao || c.description || c.label
          if (!nome && nomeCand) nome = String(nomeCand)
        }
      })

      return {
        id,
        nome: this.toStringTrim(nome),
      }
    },
    formatarValor(valor) {
      if (valor === null || valor === undefined || valor === '') return ' '
      try {
        return new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        }).format(valor)
      } catch (error) {
        return valor
      }
    },
    async carregarDocumentosParaResumo(dealId) {
      if (!dealId) return
      try {
        const res = await documentosApi.getDealDocuments(dealId)
        const docs = (res && res.data) ? res.data : []
        const arr = Array.isArray(docs) ? docs : []
        this.documentosLista = arr.slice()

        const totalDocs = arr.length
        const contratos = arr.filter(d => this.isDocumentoContrato(d)).length

        this.documentosResumo = {
          ...this.documentosResumo,
          total: totalDocs,
          contratos,
        }

        this.contratosResumo = {
          ...this.contratosResumo,
          total: contratos,
        }
      } catch (e) {
        this.documentosLista = []
        this.documentosResumo = { ...this.documentosResumo, total: 0, contratos: 0 }
        this.contratosResumo = { ...this.contratosResumo, total: 0 }
      }
    },
    async carregarPessoasEmpresa(empresaId) {
      this.pessoasEmpresa = []
      if (!empresaId) return
      this.carregandoPessoasEmpresa = true
      try {
        const res = await empresaApi.getPessoasEmpresa(empresaId)
        const payload = res && res.data ? res.data : res
        this.pessoasEmpresa = Array.isArray(payload) ? payload : []
      } catch (e) {
        this.pessoasEmpresa = []
      } finally {
        this.carregandoPessoasEmpresa = false
      }
    },
    hidratarCamposLivresDoCadastro(empresa) {
      if (!empresa) return
      const hydrated = oppUtils.hidratarCamposLivresDoCadastro(empresa)
      if (!this.empresaLivres) this.empresaLivres = {}
      this.empresaLivres = { ...this.empresaLivres, ...hydrated }
    },

    extrairCnaePrincipal(empresa) {
      return oppUtils.extrairCnaePrincipal(empresa)
    },

    extrairEnquadramento(empresa) {
      return oppUtils.extrairEnquadramento(empresa)
    },

    async copiarCnpj() {
      const texto = this.empresaHeaderCnpjRaw
      if (!texto) return
      await this.copiarTexto(texto, 'CNPJ copiado!')
    },

    async copiarTexto(texto, msgSucesso = 'Copiado!') {
      if (!texto) return
      try {
        if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(texto)
        } else {
          const textarea = document.createElement('textarea')
          textarea.value = texto
          textarea.setAttribute('readonly', '')
          textarea.style.position = 'absolute'
          textarea.style.left = '-9999px'
          document.body.appendChild(textarea)
          textarea.select()
          document.execCommand('copy')
          document.body.removeChild(textarea)
        }
        if (this.$sucesso) this.$sucesso(msgSucesso)
      } catch (e) {
        if (this.$erro) this.$erro('Não foi possível copiar.')
      }
    },

    async carregarEmpresaCadastro(empresaId) {
      this.empresaCadastro = null
      if (!empresaId) return
      this.carregandoEmpresaCadastro = true
      try {
        const response = await oppUtils.getEmpresa(empresaId)
        this.empresaCadastro = response && response.data ? response.data : null
        this.hidratarCamposLivresDoCadastro(this.empresaCadastro)
      } catch (error) {
        this.empresaCadastro = null
      } finally {
        this.carregandoEmpresaCadastro = false
      }
    },
    novaOportunidadeBase() {
      return oppUtils.novaOportunidadeBase()
    },
    onPropostasStats(payload) {
      const p = payload || {}
      if (p.propostas) this.propostasResumo = { ...this.propostasResumo, ...p.propostas }
      if (p.contratos) this.contratosResumo = { ...this.contratosResumo, ...p.contratos }

      const pacoteNome = (p.pacoteContratoNome || '').trim()
      if (p.pacoteContratoNome !== undefined && pacoteNome) this.pacoteContratoNome = pacoteNome

      if (p.honorariosValor !== undefined && p.honorariosValor !== null && p.honorariosValor !== '') {
        this.honorariosValor = p.honorariosValor
      }
    },
    formatarEnderecoEmpresa(empresa) {
      return oppUtils.formatarEnderecoEmpresa(empresa)
    },

    pct(qtd, total) {
      const t = Number(total) || 0
      const q = Number(qtd) || 0
      if (!t) return 0
      return Math.max(0, Math.min(100, (q / t) * 100))
    },
    onDocumentosStats(payload) {
      const d = payload || {}

      const documentosTotal = Number(d.documentosTotal)
      const contratosDocsTotal = Number(d.contratosDocsTotal)

      const lista = d.itens || d.items || d.documentos || d.lista || d.rows || d.data || []
      const arr = Array.isArray(lista) ? lista : []

      if (arr.length) this.documentosLista = arr.slice()

      let totalDocs = 0
      if (Number.isFinite(documentosTotal) && documentosTotal >= 0) {
        totalDocs = documentosTotal
      } else if (arr.length) {
        totalDocs = arr.length
      } else if (Array.isArray(this.documentosLista)) {
        totalDocs = this.documentosLista.length
      }

      let contratos = 0
      if (Number.isFinite(contratosDocsTotal) && contratosDocsTotal >= 0) {
        contratos = contratosDocsTotal
      } else if (d.contratos !== undefined && Number.isFinite(Number(d.contratos))) {
        contratos = Number(d.contratos)
      } else if (Array.isArray(this.documentosLista)) {
        contratos = this.documentosLista.filter(doc => this.isDocumentoContrato(doc)).length
      }

      this.documentosResumo = {
        ...this.documentosResumo,
        total: totalDocs,
        contratos,
      }

      this.contratosResumo = {
        ...this.contratosResumo,
        total: contratos,
      }
    },
    statusBadgeClass(status) {
      const s = (status || '').toLowerCase()
      if (s.includes('perdid') || s.includes('cancel')) return 'deal-status--bad'
      if (s.includes('aguard') || s.includes('andament')) return 'deal-status--warn'
      if (s.includes('conclu') || s.includes('ganh')) return 'deal-status--ok'
      return ''
    },

    async carregarPacoteContratoDaPropostaDetalhada(propostaId) {
      if (!propostaId) return
      try {
        const res = await propostaApi.getProposta(propostaId)
        const proposta = (res && res.data) ? res.data : null

        const nomePacote = this.extrairNomePlanoOuPacote(proposta)
        if (nomePacote) this.pacoteContratoNome = nomePacote

        const honorarios = this.extrairHonorarios(proposta)
        if (honorarios !== null && honorarios !== undefined) {
          this.honorariosValor = honorarios
        }
      } catch (e) {
        // ignore
      }
    },

    isDocumentoContrato(doc) {
      if (!doc) return false

      const tipo = this.normalizarTipoDocumento(doc)

      if (Number.isFinite(tipo.id) && tipo.id === 1) return true

      const nomeTipo = String(tipo.nome || '').toLowerCase()
      if (nomeTipo.includes('contrato') || nomeTipo.includes('contract')) return true

      const desc = String(doc.descricao || doc.description || doc.details || '').toLowerCase()
      if (desc.includes('contrato') || desc.includes('contract')) return true

      const nomeArquivo = String(doc.nome || doc.name || doc.filename || doc.fileName || '').toLowerCase()
      if (nomeArquivo.includes('contrato') || nomeArquivo.includes('contract')) return true

      return false
    },
    extrairNomePlanoOuPacote(p) {
      if (!p) return ''

      const candidatos = [
        p.pacoteContratoNome,
        p.pacoteContrato,
        p.propostaPacote && (p.propostaPacote.nome || p.propostaPacote.name),
        p.propostaPacote && p.propostaPacote.pacoteServico && (p.propostaPacote.pacoteServico.nome || p.propostaPacote.pacoteServico.name),
        Array.isArray(p.propostasPacotes) && p.propostasPacotes.length && (p.propostasPacotes[0].nome || p.propostasPacotes[0].name),
        Array.isArray(p.propostasPacotes) && p.propostasPacotes.length && p.propostasPacotes[0].pacoteServico && (p.propostasPacotes[0].pacoteServico.nome || p.propostasPacotes[0].pacoteServico.name),
        p.pacoteNome,
        p.planoNome,
        p.planName,
        p.nomePlano,
        p.planSelectedName,
        p.selectedPlanName,
        p.planoEscolhido && (p.planoEscolhido.nome || p.planoEscolhido.name),
        p.planoSelecionado && (p.planoSelecionado.nome || p.planoSelecionado.name),
        p.plano && (p.plano.nome || p.plano.name),
        p.plan && (p.plan.nome || p.plan.name),
        p.selectedPlan && (p.selectedPlan.nome || p.selectedPlan.name),
        p.pacote && (p.pacote.nome || p.pacote.name),
        p.package && (p.package.nome || p.package.name),
      ]

      const nome = candidatos
        .map(v => this.toStringTrim(v))
        .find(v => v && v.length > 0)

      return nome || ''
    },
    abrirPaginaEmpresaOuPessoa() {
      const opp = this.oportunidade || {}

      const companyId = opp.companyId || (opp.company && opp.company.id)
      if (companyId) {
        let resolved = null
        try {
          resolved = this.$router && this.$router.resolve ? this.$router.resolve({ name: 'editar-emp', params: { id: companyId } }) : null
        } catch (e) {
          resolved = null
        }
        const url = resolved && resolved.href ? resolved.href : `/empresas/editar/${companyId}`
        window.open(url, '_blank')
        return
      }

      /* eslint-disable-next-line */
      const personId = opp.personId || opp.cliente && opp.cliente.id
      if (personId) {
        let resolved = null
        try {
          resolved = this.$router && this.$router.resolve ? this.$router.resolve({ name: 'editar-pessoa', params: { id: personId } }) : null
        } catch (e) {
          resolved = null
        }
        const url = resolved && resolved.href ? resolved.href : `/pessoas/editar/${personId}`
        window.open(url, '_blank')
        return
      }

      window.open('/pessoas/visualizar', '_blank')
    },
    extrairHonorarios(p) {
      const candidatos = [
        p.valorHonorarios,
        p.valorTotalPropostaAuditar,
        p.valorTotalChecklist,
        p.valorTotalPropostaRCC,

        p.honorarios,
        p.valorPlano,
        p.planoValor,
        p.valorDoPlano,
        p.plano && (p.plano.valor || p.plano.value || p.plano.preco || p.plano.price),
        p.plan && (p.plan.valor || p.plan.value || p.plan.preco || p.plan.price),
        p.valor,
        p.total,
        p.totalValue,
      ]
      const num = candidatos
        .map(v => (typeof v === 'string'
          ? Number(String(v).replace(/[^\d,-]/g, '').replace(/\./g, '').replace(',', '.'))
          : Number(v)))
        .find(v => Number.isFinite(v) && v > 0)
      return Number.isFinite(num) ? num : null
    },
    onModalHidden() {
      this.propostaIdAtual = null
      this.oportunidade = this.novaOportunidadeBase()
      this.empresaCadastro = null
      this.pessoasEmpresa = []
      this.carregandoPessoasEmpresa = false
      this.contatosAberto = true

      try {
        if (this.$route && this.$route.name === 'detalhes-oportunidade') {
          const returnTo = this.$route.query && this.$route.query.returnTo ? String(this.$route.query.returnTo) : ''
          if (returnTo && returnTo !== this.$route.fullPath) {
            this.$router.push(returnTo).catch(() => {})
          } else {
            this.$router.push({ name: 'painel-oportunidades' }).catch(() => {})
          }
        }
      } catch (e) {
        // ignore
      }
    },
  },
}
</script>
